import React, { useState, useCallback, useEffect } from "react";
import { Col, Input, Label, Row, TabPane, Spinner, Button } from "reactstrap";
import { toast } from "react-toastify";
import { APIClient } from "../../../../helpers/api_helper";

const apiClient = new APIClient();

const TabRelatorio = () => {
  const [loading, setLoading] = useState(false);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  const handleExportCSV = async () => {
    setLoading(true);
    const params = {};

    if (dataInicio) params.data_inicio = dataInicio;
    if (dataFim) params.data_fim = dataFim;

    const response = await apiClient.get("/cripto-td/export-cliente-csv", params);

    if (response.sucesso) {
      const csvContent = response.dados;

      const blob = new Blob([csvContent], { type: "text/csv" });
      const blobURL = window.URL.createObjectURL(blob);

      const fileName = `compras-diarias_${dataInicio}_${dataFim}.csv`;
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(blobURL);
      setDataFim("");
      setDataInicio("");
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
  };

  return (
    <TabPane tabId="4">
      {loading ? (
        <Spinner />
      ) : (
        <Row>
          <div className="mb-3">
            <h5>Compras Diárias</h5>
          </div>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Data Início</Label>
              <Input
                type="date"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
              />
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <Label className="form-label">Data Fim</Label>
              <Input
                type="date"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
              />
            </div>
          </Col>
          <Col lg={12}>
            <div className="mb-3">
              <Button
                color="primary"
                className="btn mb-4"
                disabled={loading}
                onClick={handleExportCSV}
              >
                Exportar CSV
              </Button>
            </div>
          </Col>
        </Row>
      )}
    </TabPane>
  );
};

export default TabRelatorio;
